var $0c92d39bbbe2e63b$exports = {};
const $0c92d39bbbe2e63b$var$canvas = document.querySelector("#mainCanvas");
const $0c92d39bbbe2e63b$var$ctx = $0c92d39bbbe2e63b$var$canvas.getContext("2d");
console.log("hexgrid");
const $0c92d39bbbe2e63b$var$screenWidth = $0c92d39bbbe2e63b$var$canvas.width = window.innerWidth;
const $0c92d39bbbe2e63b$var$screenHeight = $0c92d39bbbe2e63b$var$canvas.height = window.innerHeight;
const $0c92d39bbbe2e63b$var$angle = 2 * Math.PI / 6;
$0c92d39bbbe2e63b$var$ctx.lineWidth = 3;
$0c92d39bbbe2e63b$var$ctx.strokeStyle = "black";
// x and y are center point
const $0c92d39bbbe2e63b$var$drawHexagon = (x, y, radius)=>{
    $0c92d39bbbe2e63b$var$ctx.beginPath();
    for(let i = 0; i < 6; i++)$0c92d39bbbe2e63b$var$ctx.lineTo(x + radius * Math.cos($0c92d39bbbe2e63b$var$angle * i), y + radius * Math.sin($0c92d39bbbe2e63b$var$angle * i));
    $0c92d39bbbe2e63b$var$ctx.closePath();
    $0c92d39bbbe2e63b$var$ctx.fill();
    $0c92d39bbbe2e63b$var$ctx.stroke();
};
const $0c92d39bbbe2e63b$var$drawGrid = (width, height, radius)=>{
    const cos = Math.cos($0c92d39bbbe2e63b$var$angle);
    const sin = Math.sin($0c92d39bbbe2e63b$var$angle);
    let total = 0;
    for(let gridY = 0; gridY < height; gridY++)for(let gridX = 0; gridX < width; gridX++){
        const x = radius + gridX * radius * (1 + cos);
        const y = radius + (gridX % 2 === 0 ? 0 : radius * sin) + 2 * radius * sin * gridY;
        if (x >= $0c92d39bbbe2e63b$var$screenWidth) break;
        if (y >= $0c92d39bbbe2e63b$var$screenHeight) break;
        $0c92d39bbbe2e63b$var$ctx.fillStyle = "#1c133f";
        $0c92d39bbbe2e63b$var$drawHexagon(x, y, radius);
        total += 1;
    }
    console.log(total);
};
$0c92d39bbbe2e63b$var$drawGrid(200, 20, 20);


//# sourceMappingURL=index.81b5889b.js.map
